import 'css-chunk:src/app/containers/Projects/AutomationPage/AutomationPage/data-table.scss';export default {
  "TableDef": "_TableDef_d9e4a_1",
  "DragLine": "_DragLine_d9e4a_5"
};